var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 13.333C10.9468 13.333 13.3335 10.9463 13.3335 7.99967C13.3335 5.05301 10.9468 2.66634 8.00016 2.66634C5.0535 2.66634 2.66683 5.05301 2.66683 7.99967C2.66683 10.9463 5.0535 13.333 8.00016 13.333ZM8.00016 1.33301C11.6668 1.33301 14.6668 4.33301 14.6668 7.99967C14.6668 11.6663 11.6668 14.6663 8.00016 14.6663C4.3135 14.6663 1.3335 11.6663 1.3335 7.99967C1.3335 4.33301 4.3335 1.33301 8.00016 1.33301ZM8.3335 8.66634H7.3335V4.66634H8.3335V7.50634L10.8002 6.08634L11.3002 6.95301L8.3335 8.66634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.6c3dc60450e0109324b4fc27e5e67d29.svg";
export { ForwardRef as ReactComponent };